function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import WmsLayer from '../layers/WmsLayer';
import WmtsLayer from '../layers/WmtsLayer';
import DrawLayer from '../layers/DrawLayer';
import XYZLayer from '../layers/XYZLayer';
import VectorLayer from '../layers/LegacyVectorLayer';
import './LayerGroup.css';
var checkBoxCheckedIcon = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 0h-24c-2.2 0-4 1.8-4 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4v-24c0-2.2-1.8-4-4-4zM14 24.828l-7.414-7.414 2.828-2.828 4.586 4.586 9.586-9.586 2.828 2.828-12.414 12.414z"
}));
var checkBoxUncheckedIcon = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 0h-24c-2.2 0-4 1.8-4 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4v-24c0-2.2-1.8-4-4-4zM28 28h-24v-24h24v24z"
}));

/**
 * An optional layer group.
 * Presents a button (div) on the map, and the user can click it to expand a list of layers.
 * The list will be populated with all of its children (DrawLayers, VectorLayers and WmsLayers) that have the name-property set.
 * There are default svg-icons in use, but they can be overridden by sending them in as props (icon, activeIcon, inactiveIcon)
 */
var LayerGroup = /*#__PURE__*/function (_React$Component) {
  function LayerGroup(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.showList = _this.showList.bind(_this);
    var activeLayers = {};
    var layers = _this.getEnabledLayers().map(function (child) {
      return child.props.id;
    });
    if (!props.enabledLayers) {
      layers.forEach(function (element) {
        activeLayers[element] = true;
      });
    } else {
      var layersArray = props.enabledLayers;
      if (props.singleSelect) {
        activeLayers[layersArray[0]] = true;
      } else {
        layersArray.forEach(function (element) {
          activeLayers[element] = true;
        });
      }
    }
    _this.state = {
      showList: true,
      activeLayerId: null,
      activeLayers: activeLayers
    };
    return _this;
  }
  _inheritsLoose(LayerGroup, _React$Component);
  var _proto = LayerGroup.prototype;
  _proto.toggleLayer = function toggleLayer(id, suppress) {
    var _this2 = this;
    var singleSelect = this.props.singleSelect;
    var activeLayers;
    if (singleSelect) {
      var _activeLayers;
      if (this.state.activeLayers[id]) return;
      activeLayers = {
        activeLayers: (_activeLayers = {}, _activeLayers[id] = !this.state.activeLayers[id], _activeLayers)
      };
    } else {
      var _Object$assign;
      activeLayers = {
        activeLayers: Object.assign(this.state.activeLayers, (_Object$assign = {}, _Object$assign[id] = !this.state.activeLayers[id], _Object$assign))
      };
    }
    this.setState(activeLayers, function () {
      if (!suppress && _this2.props.onLayersChanged) _this2.props.onLayersChanged(Object.keys(_this2.state.activeLayers));
    });
  };
  _proto.isLayerActive = function isLayerActive(id) {
    return !!this.state.activeLayers[id];
  };
  _proto.showList = function showList(e) {
    this.setState({
      showList: !this.state.showList
    });
  };
  _proto.getEnabledLayers = function getEnabledLayers() {
    var disabledLayersArray = this.props.disabledLayers || [];
    var childs = React.Children.toArray(this.props.children);
    return childs.filter(function (child) {
      return (child.type === WmsLayer || child.type === WmtsLayer || child.type === DrawLayer || child.type === VectorLayer || child.type === XYZLayer) && disabledLayersArray.indexOf(child.props.id) === -1;
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      children = _this$props.children,
      icon = _this$props.icon,
      activeIcon = _this$props.activeIcon,
      inactiveIcon = _this$props.inactiveIcon,
      name = _this$props.name;
    var showList = this.state.showList;
    var checkedIcon = activeIcon || checkBoxCheckedIcon;
    var uncheckedIcon = inactiveIcon || checkBoxUncheckedIcon;
    var activeLayers = [];
    var layers = React.Children.map(children, function (child) {
      if (!child) return;
      var childProps = child.props || {};
      if ((child.type === WmsLayer || child.type === WmtsLayer || child.type === DrawLayer || child.type === VectorLayer || child.type === XYZLayer) && childProps.name) {
        _this3.isLayerActive(childProps.id) && activeLayers.push(child);
        return /*#__PURE__*/React.createElement("div", {
          key: childProps.id,
          className: "layer-group--list-item-container",
          onClick: function onClick() {
            return _this3.toggleLayer(childProps.id);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "layer-group--list-item",
          key: childProps.id
        }, /*#__PURE__*/React.createElement("span", {
          className: "icon"
        }, _this3.isLayerActive(childProps.id) ? checkedIcon : uncheckedIcon), /*#__PURE__*/React.createElement("span", {
          className: "text"
        }, childProps.name)));
      }
      return child;
    });
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: showList ? 'layer-group--container' : 'layer-group--container svg-size'
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this.showList
    }, /*#__PURE__*/React.createElement("div", {
      className: "layer-group--header"
    }, icon && /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, icon), /*#__PURE__*/React.createElement("span", {
      className: "text"
    }, name))), showList && layers), activeLayers);
  };
  return LayerGroup;
}(React.Component);
LayerGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The children of the LayerGroup.
   */
  children: PropTypes.node,
  /**
   *  Callback function
   */
  onLayersChanged: PropTypes.func,
  /**
   *  Icon for LayerGroup, if not set will use default one
   */
  icon: PropTypes.element,
  /**
   *  Icon for active/selected WmsLayer, if not set will use default one
   */
  activeIcon: PropTypes.element,
  /**
   *  Icon for inactive WmsLayer, if not set will use default one
   */
  inactiveIcon: PropTypes.element,
  /**
   *  Array of WmsLayers that will not load at beginning of sesion
   */
  disabledLayers: PropTypes.array,
  /**
   * Array of WmsLayers that will load at beginning of sesion
   */
  enabledLayers: PropTypes.array,
  /**
   *  Name
   */
  name: PropTypes.string,
  /**
   *  If set, enables you to select only one WmsLayer at a time
   */
  singleSelect: PropTypes.bool
} : {};
export default LayerGroup;